<template>
    <column cols="full" class="absolute h-full overflow-x-hidden">
        <row class="h-full" justify="center">
            <column style="max-width: 1920px; width: 100%; height: 100%;" class="relative">
                <!--            Desktop-->
                <div class="xs:hidden">
                    <!--        Top two background layers-->
                    <div class="rotated-background-section"
                         style="background-color: #082441; left: 58px; top: 138px; transform: translateX(-323px) translateY(-625px) rotateZ(-7deg);"></div>
                    <div class="rotated-background-section"
                         style="background: linear-gradient(to bottom left, #0174EA, #013A75); left: 58px; top: 138px; transform: translateX(-689px) translateY(-295px) rotateZ(-7deg);"></div>
                    <!--        why fitt background layer-->
                    <div id="colored_background_section_why_fitt"
                         class="rotated-background-section"
                         style="background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0)); width: 1944px; height: 916px; opacity: 0.05;"></div>
                    <!--        customization background sections-->
                    <div
                            id="colored_background_section_customization_light"
                            class="rotated-background-section"
                            style="background: linear-gradient(to top, #082441, #00EBE8); left: 123px; top: 292px; width: 4929px; height: 2324px;"></div>
                    <div class="rotated-background-section"
                         style="background: #0174EA; left: 89px; top: 210px; transform: translateX(769px) translateY(4562px) rotateZ(-7deg); width: 3552px; height: 1675px;"></div>
                    <div
                            id="colored_background_section_customization_dark"
                            class="rotated-background-section"
                            style="background: #082441; left: 123px; top: 292px; width: 4929px; height: 2324px;"></div>
                    <div
                            id="colored_background_section_usergroups_dark"
                            class="rotated-background-section"
                            style="background: #082441; left: 123px; top: 292px; width: 4929px; height: 2324px;"></div>
                </div>
                <!--            Mobile-->
                <div class="sm:hidden">
                    <div class="rotated-background-section"
                         style="background-color: #082441; left: 58px; top: 138px; transform: translateX(-1661px) translateY(-651px) rotateZ(-7deg);"></div>
                    <div class="rotated-background-section"
                         style="background: linear-gradient(to bottom left, #0174EA, #013A75); left: 58px; top: 138px; transform: translateX(-2027px) translateY(-321px) rotateZ(-7deg);"></div>
                    <!--        why fitt background layer-->
                    <div class="rotated-background-section"
                         style="background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0)); transform: translateX(-129px) translateY(1773px) rotateZ(-7deg); width: 1944px; height: 916px; opacity: 0.05;"></div>
                    <!--        customization background sections-->
<!--                    transform: translateX(-3767px) translateY(4814px) rotateZ(-7deg);-->
                    <div
                            id="mobile_colored_background_section_customization_light"
                            class="rotated-background-section"
                         style="background: linear-gradient(to top, #082441, #00EBE8); width: 4415px; height: 2082px;"></div>
                    <div
                            id="mobile_colored_background_section_usergroups_light"
                            class="rotated-background-section"
                         style="background: #0174EA; width: 2812px; height: 1326px; left: 70px;"></div>
                    <div
                            id="mobile_colored_background_section_usergroups_dark"
                            class="rotated-background-section"
                         style="background: #082441; width: 4415px; height: 3978px;"></div>
<!--                    transform: translateX(-3153px) translateY(4795px) rotateZ(-7deg);-->
                </div>
            </column>
        </row>
    </column>
</template>

<script>
    export default {
        components: {}
    };
</script>

<style scoped>
    .rotated-background-section {
        width: 2332px;
        height: 1099px;
        position: absolute;
        border-radius: 166px;
        z-index: -1;
    }

    @media only screen and (max-width: 341px) {
        #mobile_colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(4935px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4900px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_light {
            transform: translateX(-126px) translateY(6724px) rotateZ(-7deg);
        }

        /*#colored_background_section_customization_dark {*/
        /*    transform: translateX(-3038px) translateY(3971px) rotateZ(-7deg);*/
        /*}*/
    }

    @media only screen and (min-width: 342px) and (max-width: 359px) {
        #mobile_colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(4835px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4800px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_light {
            transform: translateX(-126px) translateY(6724px) rotateZ(-7deg);
        }

        /*#colored_background_section_customization_dark {*/
        /*    transform: translateX(-3038px) translateY(3971px) rotateZ(-7deg);*/
        /*}*/
    }

    @media only screen and (min-width: 360px) and (max-width: 441px) {
        /*#colored_background_section_why_fitt {*/
        /*    transform: translateX(100px) translateY(1871px) rotateZ(-7deg);*/
        /*}*/

        #mobile_colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(4685px) rotateZ(-7deg);
        }

        /*#colored_background_section_customization_dark {*/
        /*    transform: translateX(-3038px) translateY(3971px) rotateZ(-7deg);*/
        /*}*/

        #mobile_colored_background_section_usergroups_light {
            transform: translateX(-126px) translateY(6724px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4650px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 442px) and (max-width: 639px) {
        /*#colored_background_section_why_fitt {*/
        /*    transform: translateX(100px) translateY(1871px) rotateZ(-7deg);*/
        /*}*/

        #mobile_colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(4585px) rotateZ(-7deg);
        }

        /*#colored_background_section_customization_dark {*/
        /*    transform: translateX(-3038px) translateY(3971px) rotateZ(-7deg);*/
        /*}*/

        #mobile_colored_background_section_usergroups_light {
            transform: translateX(-126px) translateY(6724px) rotateZ(-7deg);
        }

        #mobile_colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4550px) rotateZ(-7deg);
        }
    }


    @media only screen and (min-width: 640px) and (max-width: 768px) {
        #colored_background_section_why_fitt {
            transform: translateX(100px) translateY(1871px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(4185px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(4171px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(5500px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 769px) and (max-width: 1024px) {
        #colored_background_section_why_fitt {
            transform: translateX(100px) translateY(1871px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3985px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3971px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4650px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 1025px) and (max-width: 1152px) {
        #colored_background_section_why_fitt {
            left: 49px;
            top: 115px;
            transform: translateX(267px) translateY(1771px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3835px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3821px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4638px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 1153px) and (max-width: 1366px) {
        #colored_background_section_why_fitt {
            left: 49px;
            top: 115px;
            transform: translateX(267px) translateY(1771px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3835px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3821px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4538px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 1367px) and (max-width: 1500px) {
        #colored_background_section_why_fitt {
            left: 49px;
            top: 115px;
            transform: translateX(267px) translateY(1771px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3835px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3821px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4338px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 1501px) and (max-width: 1919px) {
        #colored_background_section_why_fitt {
            left: 49px;
            top: 115px;
            transform: translateX(267px) translateY(1771px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3835px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3821px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4238px) rotateZ(-7deg);
        }
    }

    @media only screen and (min-width: 1920px) {
        #colored_background_section_why_fitt {
            left: 49px;
            top: 115px;
            transform: translateX(267px) translateY(1771px) rotateZ(-7deg);
        }

        #colored_background_section_customization_light {
            transform: translateX(-3623px) translateY(3735px) rotateZ(-7deg);
        }

        #colored_background_section_customization_dark {
            transform: translateX(-3038px) translateY(3721px) rotateZ(-7deg);
        }

        #colored_background_section_usergroups_dark {
            transform: translateX(-2987px) translateY(4138px) rotateZ(-7deg);
        }
    }
</style>